import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'staffName',
  standalone: true
})
export class TeacherNamePipe implements PipeTransform {

  transform(teacher: { title: string, firstName: string, lastName: string } | null | undefined): string {
    if (!teacher) return '';
    const { title, firstName, lastName } = teacher;
    return `${title} ${firstName.charAt(0)}.${lastName}`;
  }
}
